import {
  buildLeadPayload,
  getLeadAuthHeaders,
  saveLeadSessionProfile,
  profileToFormDefaults,
  getLeadSessionProfile,
  markListingLeadSent,
} from './scrapedLeadSubmit';

function payloadToSessionProfile(payload) {
  return {
    applicantName: payload.applicantName,
    applicantEmail: payload.applicantEmail,
    applicantPhone: payload.applicantPhone,
    desiredStartDate: payload.desiredStartDate,
    desiredEndDate: payload.desiredEndDate,
    stayDurationMonths: payload.stayDurationMonths,
    budgetMax: payload.budgetMax,
    occupants: payload.occupants,
    stayReason: payload.stayReason,
    comments: payload.comments,
    consentLeadSharing: payload.consentLeadSharing,
    privacyPolicyVersion: payload.privacyPolicyVersion,
  };
}

/** @returns {{ ok: boolean, status: number, data: any, leadId?: string }} */
export async function submitHiveLead(colivingId, form, { city, searchFilters }) {
  const todayDate = new Date().toISOString().split('T')[0];
  const payload = buildLeadPayload(form, { city, searchFilters, todayDate });
  const headers = await getLeadAuthHeaders();
  const res = await fetch(`/api/colivings/hive-leads/${colivingId}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (res.ok) {
    saveLeadSessionProfile(payloadToSessionProfile(payload));
    markListingLeadSent(colivingId);
  }
  return { ok: res.ok, status: res.status, data, leadId: data?.leadId };
}

export { getLeadSessionProfile, profileToFormDefaults };
